<template>
  <v-footer class="pr-0 pl-0 pt-0 pb-0" app>
    <v-bottom-navigation dark color="blue" v-model="activeBottomBar" horizontal grow>
      <v-btn @click="goToGround" value="ground" class="nav-btn">
        <span>广场</span>
        <v-icon>mdi-palette</v-icon>
      </v-btn>

      <v-btn value="my" @click="goToMy" class="nav-btn">
        <span>我的</span>
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-btn absolute dark fab top right color="blue" @click="goToUpload" class="float-btn">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      activeBottomBar: this.$route.name === 'DbAsMy' ? 'my' : 'ground'
    }
  },
  name: 'DbAsFooter',
  methods: {
    goToUpload() {
      if (!this.$store.state.user.token) {
        this.$router.push({
          path: '/vdb_login/sms',
          query: {
            ruri: `/imgu/upload/${this.$route.params.type}`
          }
        })
      } else {
        this.$router.push(`/imgu/upload/${this.$route.params.type}`)
      }
    },
    goToMy() {
      if (this.$route.name === 'DbAsMy') {
        return
      }
      if (!this.$store.state.user.token) {
        this.$router.push({
          path: '/vdb_login/sms',
          query: {
            ruri: `/imgu/${this.$route.params.type}/my/0`
          }
        })
        return
      }
      this.$router.push({
        path: `/imgu/${this.$route.params.type}/my/0`,
        query: this.$route.query
      })
    },
    goToGround() {
      if (this.$route.name === 'DbAs') {
        return
      }
      this.$router.push({
        path: `/imgu/${this.$route.params.type}/ground/0`,
        query: this.$route.query
      })
    }
  }
}
</script>
<style scoped>
.float-btn {
  top: -120px !important;
}
.nav-btn {
  height: inherit !important;
}
</style>